import {post} from "@/utils/request";

export default class apiUserInfo{
  static async save(data){
    return post('/home/user_info/save', data)
  }

  static async GetSubscribeList(page=1, pageSize=10){
    return post('/home/user_info/getSubscribeList', {page, pageSize})
  }

  static async GetFansList(page=1, pageSize=10){
    return post('/home/user_info/getFansList', {page, pageSize})
  }

  static async sendSmsCode(mobile){
    return post('/home/user_info/sendSmsCode', {mobile})
  }

  static async saveMobile(mobile, code){
    return post('/home/user_info/saveMobile', {mobile, code})
  }

  static async GetShowIdByUid(uid){
    return post('/home/user_info/getShowIdByUid', {uid})
  }

  static async search(keyword, page=1, pageSize=10){
    return post('/home/user_info/search', {keyword, page, pageSize})
  }

  static async getDuplicateConfig(){
    return post('/home/user_info/getDuplicateConfig')
  }

  static async setDuplicateConfig(duplicateCheckType, isCheckOnBatch){
    return post('/home/user_info/setDuplicateConfig', {duplicateCheckType, isCheckOnBatch})
  }
}
